module.exports = __webpack_public_path__ + "assets/svg/Icons/48/dashboard-blue-57dbc9.svg";